import React, { useState } from 'react';
import axios from 'axios';
import '../../css/Main/NavBar.css';
import { useNavigate } from 'react-router-dom';
import slugify from "slugify";

const Search = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [products, setProducts] = useState([]);
  const API = process.env.REACT_APP_BACKEND_URL;

  const handleSearch = async (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() === '') {
      setProducts([]);
      return;
    }

    try {
      const response = await axios.get(`${API}/wproducts/search?query=${query}`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const handleNavigate = (product) => {
    const categorySlug = slugify(product.category, { lower: true, strict: true });
    const subcategorySlug = slugify(product.subcategory, { lower: true, strict: true });
    const productSlug = slugify(product.product_name || product.name, { lower: true, strict: true });
    navigate(`/termek/${categorySlug}/${subcategorySlug}/${productSlug}/${product.id}`);
  };

  return (
    <div className='search-container'>
      <input
        type="text"
        placeholder='Search'
        value={searchQuery}
        onChange={handleSearch}
      />

      {products.length > 0 && (
        <div className="results-box">
          {products.map((product) => (
            <div 
              key={product.id} 
              className="product-item" 
              onClick={() => handleNavigate(product)}
            >
              <img src={`/uploads/${product.image?.split(',')[0]?.trim()}`} alt={product.product_name || product.name} />
              <p>{product.product_name || product.name}</p>              
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Search;